import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from "react-router-dom";
import '../styles/Head.css';
import GlobalSettings from './GlobalSettings.js';
import pens from '../images/Stifte.png';
import PageHeader from './PageHeader.js';
import PageFooter from './PageFooter.js';
import { GlobalStateContext } from './GlobalStateContext.js';

const Exit = () => {
    
    const [title, setTitle] = useState([]);
    const [topic, setTopic] = useState([]);
    const [bodytext1, setBodytext1] = useState([]);
    const [bodytext2, setBodytext2] = useState([]);
    const [bodytext3, setBodytext3] = useState([]);
    const [buttontext, setButtontext] = useState([]);
    const { valid, surveyTitle, surveyName, surveyMode} = useContext(GlobalStateContext);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
               /* const responseText = await fetch('/api/text');
                const resultText = await responseText.json();
                setTitle(resultText);*/

                const responseExitText = await fetch(`/api/exittext/${GlobalSettings.languageId}`);
                const resultExitText = await responseExitText.json();
                setBodytext1(resultExitText);

                const responseExitBtn = await fetch(`/api/exitbtn/${GlobalSettings.languageId}`);
                const resultExitBtn = await responseExitBtn.json();
                setButtontext(resultExitBtn);
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
    }, []);

    const custom_close = () => {
        window.opener = null;
        window.open('', '_self');
        window.close();
    };

    if (valid === false) {
        return (
            <div>
                <div>
                    <div className="headLine_3"><div className="head_Text2">Fehler: Ungültiger Token</div></div>
                    <div className="orangeLine"></div>
                </div>
                <div className="containerBody">
                    <div className="body2">Bitte kehren Sie zur Startseite zurück um den gültigen Token einzugeben.</div>
                    <img src={pens} className="pens_err" alt='pens' />
                </div>
                <div className="container_Footer">
                    <div className="footer_Line">
                        <Link to="/"><button className="btnToSurvey">Zur Startseite</button></Link>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div>
                <PageHeader headerText={surveyTitle} surveyName={surveyName} mode={surveyMode} />
                <div className="questionBody">
                    <div className="bubbleInactive"></div>
                    <div className="bubbleActive">
                        <div className="bubbleTextContent">{bodytext1[0]?.text}</div>
                        <div className="bubbleFooter">
                            <div className="bubbleStart">
                                <button className="btnBubble" onClick={custom_close}>{buttontext[0]?.text}</button>
                            </div>
                        </div>
                    </div>
                    <div className="bubbleInactive"></div>
                </div>
                <PageFooter progress={100} />
            </div>
        );
    }
};

export default Exit;
